import React from 'react';
import { useProducts } from '../context/ProductContext';
import Hero from '../components/Hero';
import ProductSection from '../components/ProductSection';

const Home = () => {
  const { products, loading } = useProducts();

  if (loading) {
    return (
      <>
        <Hero />
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '50vh',
          flexDirection: 'column',
          gap: '1rem'
        }}>
          <div className="spinner"></div>
          <p>Loading delicious products...</p>
        </div>
      </>
    );
  }

  return (
    <div className="home-page">
      <Hero />
      
      {/* Chocolate Cakes */}
      <ProductSection
        id="chocolate-cakes"
        title="Chocolate Cakes"
        description="Indulge in our rich and decadent chocolate creations"
        products={products.cakes?.chocolate || []}
      />

      {/* Pineapple Cakes */}
      <ProductSection
        id="pineapple-cakes"
        title="Pineapple Cakes"
        description="Fresh, tropical flavors in every bite"
        products={products.cakes?.pineapple || []}
      />

      {/* Customized Cakes */}
      <ProductSection
        id="customized-cakes"
        title="Customized Cakes"
        description="Bring your dream cake to life with our custom designs"
        products={products.cakes?.customized || []}
      />

      {/* Jar Cakes */}
      <ProductSection
        id="jar-cakes"
        title="Jar Cakes"
        description="Portable perfection! Enjoy layers of deliciousness in our convenient jar cakes"
        products={products.jarCakes || []}
      />

      {/* Brownies */}
      <ProductSection
        id="brownies"
        title="Brownies"
        description="Rich, fudgy, and irresistible. Our brownies are the perfect treat for chocolate lovers"
        products={products.brownies || []}
      />

      {/* About Preview Section */}
      <section id="about-preview" className="section" style={{ background: 'linear-gradient(135deg, #FFF8F0 0%, #FFE8E0 100%)' }}>
        <div className="container">
          <div className="section-title">
            <h2>Why Choose Cakified?</h2>
          </div>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: 'var(--spacing-lg)',
            marginTop: 'var(--spacing-xl)'
          }}>
            <div style={{
              background: 'var(--white)',
              padding: 'var(--spacing-lg)',
              borderRadius: 'var(--radius-lg)',
              textAlign: 'center',
              boxShadow: 'var(--shadow-sm)'
            }}>
              <span style={{ fontSize: '3rem' }}>🌟</span>
              <h3 style={{ color: 'var(--accent-brown)', margin: 'var(--spacing-sm) 0' }}>Premium Quality</h3>
              <p style={{ color: 'var(--text-light)' }}>We use only the finest ingredients to create our delicious treats</p>
            </div>
            <div style={{
              background: 'var(--white)',
              padding: 'var(--spacing-lg)',
              borderRadius: 'var(--radius-lg)',
              textAlign: 'center',
              boxShadow: 'var(--shadow-sm)'
            }}>
              <span style={{ fontSize: '3rem' }}>🎂</span>
              <h3 style={{ color: 'var(--accent-brown)', margin: 'var(--spacing-sm) 0' }}>Made to Order</h3>
              <p style={{ color: 'var(--text-light)' }}>Every creation is freshly baked just for you</p>
            </div>
            <div style={{
              background: 'var(--white)',
              padding: 'var(--spacing-lg)',
              borderRadius: 'var(--radius-lg)',
              textAlign: 'center',
              boxShadow: 'var(--shadow-sm)'
            }}>
              <span style={{ fontSize: '3rem' }}>💝</span>
              <h3 style={{ color: 'var(--accent-brown)', margin: 'var(--spacing-sm) 0' }}>Handcrafted Love</h3>
              <p style={{ color: 'var(--text-light)' }}>Each dessert is made with care and attention to detail</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;